var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "full-width q-pa-md" }, [
    _c("div", { staticClass: "row items-center gutter-x-sm" }, [
      _c(
        "div",
        { staticClass: "col-auto gt-md" },
        [
          _c("q-icon", {
            attrs: { name: "timer", color: "light", size: "2rem" }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col" },
        [
          _c("recent-time-entry-input", {
            on: {
              submit: _vm.handleSubmitActiveTimeEntry,
              blur: function($event) {
                _vm.handleActiveTimeEntryUpdated("description")
              },
              select: _vm.handleSelectRecentTimeEntry
            },
            model: {
              value: _vm.timeEntry.description,
              callback: function($$v) {
                _vm.$set(_vm.timeEntry, "description", $$v)
              },
              expression: "timeEntry.description"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-auto" }, [
        _c(
          "div",
          [
            _vm.hasCustomer
              ? _c("customer-indicator", {
                  attrs: { clickable: "", customer: _vm.customer }
                })
              : _c("q-btn", {
                  attrs: { flat: "", dense: "", icon: "person", color: "faded" }
                }),
            _c("customer-popover", {
              attrs: { "active-customer": _vm.customer },
              on: { "select-customer": _vm.handleSelectCustomer }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "col-auto" }, [
        _c(
          "div",
          [
            _vm.hasProject
              ? _c("project-indicator", {
                  attrs: {
                    project: _vm.project,
                    clickable: "",
                    "hide-customer": ""
                  }
                })
              : _c("q-btn", {
                  attrs: { flat: "", dense: "", icon: "folder", color: "faded" }
                }),
            _c("project-popover", {
              attrs: { "active-project": _vm.project },
              on: { "select-project": _vm.handleSelectProject }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "col-auto" },
        [
          _c(
            "q-checkbox",
            {
              attrs: {
                "keep-color": "",
                "checked-icon": "attach_money",
                "unchecked-icon": "money_off",
                color: _vm.timeEntry.billable ? "faded" : "light"
              },
              on: {
                input: function($event) {
                  _vm.handleActiveTimeEntryUpdated("billable")
                }
              },
              model: {
                value: _vm.timeEntry.billable,
                callback: function($$v) {
                  _vm.$set(_vm.timeEntry, "billable", $$v)
                },
                expression: "timeEntry.billable"
              }
            },
            [
              _c("q-tooltip", { attrs: { delay: 300 } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("billable_tooltip")) +
                    "\n        "
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm.isRunning
        ? _c(
            "div",
            { staticClass: "col-auto" },
            [
              _c("inline-edit-duration", {
                staticClass: "q-title text-faded",
                attrs: {
                  duration: _vm.duration,
                  "started-at": _vm.timeEntry.startedAt
                    ? _vm.timeEntry.startedAt.date
                    : null,
                  "stopped-at": _vm.timeEntry.stoppedAt
                    ? _vm.timeEntry.stoppedAt.date
                    : null
                },
                on: { save: _vm.handleUpdateStartStoppedTime }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "auto" },
        [
          _vm.isRunning
            ? _c("q-btn", {
                attrs: {
                  round: "",
                  color: "red",
                  icon: "stop",
                  disabled: _vm.loading,
                  loading: _vm.loading
                },
                on: { click: _vm.handleStopActiveTimeEntry }
              })
            : _c("q-btn", {
                attrs: {
                  round: "",
                  color: "green",
                  icon: "play_arrow",
                  disabled: _vm.loading,
                  loading: _vm.loading
                },
                on: { click: _vm.handleStartTimeEntry }
              })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-auto" },
        [
          _c("q-btn", {
            attrs: {
              flat: "",
              dense: "",
              round: "",
              color: "light",
              icon: "delete",
              disabled: !_vm.isRunning || _vm.loading
            },
            on: { click: _vm.handleDeleteActiveTimeEntry }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }